'use strict';

var jsonConverter = require('./converters/astToJson');

var _require = require('./transpiler'),
    transpile = _require.transpile;

function convertXML(xmlAsString, customConverter) {
  return transpile(xmlAsString, customConverter || jsonConverter);
}

function createAST(xmlAsString) {
  return transpile(xmlAsString);
}

module.exports = {
  convertXML: convertXML,
  createAST: createAST
};